/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

gbc.constants.attributeDefaultValuesByNodeType = {
  ScrollGrid: {
    wantFixedPageSize: 1
  },
  Slider: {
    orientation: "horizontal"
  },
  WebComponent: {
    stretch: "both"
  },
  HBox: {
    orientation: "horizontal"
  }
};
/**
 * AUI attributes default values.
 *
 * @instance attributeDefaultValues
 */
gbc.constants.attributeDefaultValues = {
  acceleratorKey1: "",
  acceleratorKey3: "",
  acceleratorName2: "",
  acceleratorName3: "",
  acceleratorName4: "",
  acceleratorName: "",
  action: "",
  actionActive: 0,
  active: 0,
  aggregateText: "",
  aggregateType: "sum",
  aggregateValue: "",
  anchor: "",
  autoNext: 0,
  autoScale: 0,
  blink: 0,
  bold: 0,
  border: 0,
  bufferSize: 0,
  build: "",
  buttonTextHidden: 0,
  century: "",
  className: "",
  clickedCanvasItemId: 0,
  cloneColumns: 0,
  cloneCount: 0,
  colName: "",
  color: "",
  colorCondition: "",
  columnCount: 1,
  comment: "",
  commentLine: 0,
  commentLineHidden: 0,
  componentType: "",
  compress: 0,
  config: "",
  container: "",
  contextMenu: "yes",
  count: 0,
  currentColumn: 0,
  currentParentRow: 0,
  currentRow: 0,
  currentWindow: 0,
  cursor2: 0,
  cursor: 0,
  dataType: "",
  dbCentury: "",
  dbDate: "",
  decimalSeparator: "",
  defaultValue: "",
  defaultView: "auto",
  delimiters: "",
  dialogEventItem: 0,
  dialogEventType: "",
  dialogType: "Display",
  diameter: 0,
  dim: 0,
  dirty: 0,
  disabled: 0,
  dndAccepted: 0,
  dndBuffer: "",
  dndCanCopy: 0,
  dndCanMove: 0,
  dndFeedback: "insert",
  dndIdRef: 0,
  dndMimeTypes: "",
  dndOperation: "move",
  dndParentIdRef: 0,
  dndRequiredMimeType: "",
  doubleClick: "",
  endX: 0,
  endY: 0,
  errorLine: 0,
  exec: "",
  expanded: 0,
  expandedColumn: "",
  extentDegrees: 0,
  fieldId: "",
  fieldIdRef: 0,
  fieldOrder: 0,
  fieldSelection: 0,
  fileName: "",
  fillColor: "",
  filter: "",
  flipped: 0,
  focus: 0,
  focusOnField: 0,
  fontPitch: "default",
  formLine: 0,
  format: "",
  gridChildrenInParent: 0,
  gridHeight: null,
  gridWidth: null,
  hasChildren: 0,
  height: "",
  helpNum: 0,
  hidden: 0,
  idColumn: "",
  image: "",
  imageCollapsed: "",
  imageColumn: "",
  imageExpanded: "",
  imageLeaf: "",
  include: "",
  initializer: "",
  inputWrap: 0,
  isHotKey: 0,
  isNodeColumn: "",
  isNull: 0,
  isPassword: 0,
  isSystem: 0,
  isTimer: 0,
  isTree: 0,
  justify: "left",
  maxLength: 0,
  media: "",
  mediaAttribute: "{}",
  menuLine: 0,
  messageLine: 0,
  minHeight: 0,
  minWidth: 0,
  moduleName: "",
  multiRowSelection: 0,
  name: "",
  noEntry: 0,
  noFilter: 0,
  nodeIdRef: 0,
  notNull: 0,
  noswipe: 0,
  numAlign: 0,
  offset: 0,
  orientation: "vertical",
  pageSize: 0,
  paramCount: 0,
  parent: 0,
  parentIdColumn: "",
  picture: "",
  placeholder: "",
  posX: 0,
  posY: 0,
  procId: "",
  procIdParent: "",
  procIdWaiting: "",
  program: "",
  promptLine: 0,
  queryEditable: 0,
  required: 0,
  returnCount: 0,
  reverse: 0,
  row: 0,
  runtimeStatus: "interactive",
  sample: "",
  screenRecord: "",
  scroll: 0,
  scrollBars: "vertical",
  selected: 0,
  selection: "",
  shift: "none",
  size: 0,
  sizePolicy: "initial",
  sortColumn: -1,
  sortSpec: "",
  sortType: "",
  spacing: "normal",
  split: 0,
  splitter: 0,
  sqlDbName: "",
  sqlTabName: "",
  sqlType: "",
  startDegrees: 0,
  startX: 0,
  startY: 0,
  step: 1,
  stepX: 0,
  stepY: 1,
  stretch: "",
  stretchColumns: 0,
  stretchMin: 0,
  stretchMax: 0,
  style: "",
  tabIndex: 0,
  tabIndexRt: 0,
  tabName: "",
  tag: "",
  targetType: "",
  text: "",
  thousandsSeparator: "",
  timeout: 0,
  touched: 0,
  ttyAttr: "",
  type: "",
  uiMode: "default",
  underline: 0,
  unhidable: 0,
  unhidableColumns: 0,
  unmovable: 0,
  unmovableColumns: 0,
  unsizable: 0,
  unsizableColumns: 0,
  unsortable: 0,
  unsortableColumns: 0,
  validate: 0,
  value: "",
  valueChecked: "1",
  valueMax: null,
  valueMin: null,
  valueUnchecked: "0",
  verify: 0,
  version: "",
  visibleId: -1,
  waiting: 0,
  wantFixedPageSize: 0,
  wantReturns: 0,
  wantTabs: 0,
  width: "",
  windowStyle: "",
  xyList: ""
};
